module.exports = __webpack_public_path__ + "static/media/17545.2bbef6f5.jpg";